import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {currencyActionTypes, LoadCurrencySuccessAction} from '../actions/currency';
import {CurrencyObject} from '../models/currency';

export interface CurrencyState {
  array: CurrencyObject[];
}

const initialState: CurrencyState = {
  array: []
};

export function CurrencyReducer(state: CurrencyState = initialState, action: Action): CurrencyState {
  switch (action.type) {
    case currencyActionTypes.LOAD_SUCCESS:
      return handleLoadCurrencySuccessAction(state, action);
    default:
      return state;
  }
}

function handleLoadCurrencySuccessAction(state: CurrencyState, action: LoadCurrencySuccessAction): CurrencyState {
  const newState: CurrencyState = {
    array: action.payload
  };
  const newStateClone = _.cloneDeep(newState);
  for (let i = 0; i < newStateClone.array.length   ; i++) {
    newStateClone.array[i].name =   newStateClone.array[i].code  +  '   -   ' + newStateClone.array[i].displayName   ;
  }
  return newStateClone;
}


export const currenciesSelectors = {
  array: (state: CurrencyState) => _.get(state, 'array', []),
};


